import { render, staticRenderFns } from "./SimulatorPhonePane.vue?vue&type=template&id=4b08fc8f&scoped=true&"
import script from "./SimulatorPhonePane.vue?vue&type=script&lang=js&"
export * from "./SimulatorPhonePane.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPhonePane.vue?vue&type=style&index=0&id=4b08fc8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08fc8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VCard,VDivider,VIcon,VProgressCircular})
